import { defineStore } from 'pinia';
import { strapi } from '../transport/strapi';
import type { ISystemHostData, ISystemHostStrapiResponse } from '~/types/systemHosts';

export const useStoreSystemHosts = defineStore('systemHosts', {
  state: () => ({
    data: [] as ISystemHostData[],
    requestPromise: null as Promise<ISystemHostStrapiResponse> | null,
  }),

  getters: {
    list(state) {
      return state.data;
    },
    current(): ISystemHostData | null {
      if (import.meta.browser && window) {
        return this.list.find((h) => h?.host.toLowerCase() === window?.location?.host) || null;
      } else {
        return null;
      }
    },
    regional(): string {
      const defaultHost = '7bitcasino.com';

      if (import.meta.browser && window?.location?.host) {
        return (
          this.list.find((h) => h.host === window.location.host)?.regionalVisibleDomain ||
          defaultHost
        );
      }

      return defaultHost;
    },
  },

  actions: {
    async loadSystemHosts() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('system-hosts')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const filteredState = this.data.filter(
          (item) => !response.data.find(({ id }) => id && id === item.id)
        );

        this.data = [...filteredState, ...response.data];

        return true;
      } else {
        return false;
      }
    },
  },
});
